/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
   updateProductItemISW: (componentRegistry) => {
     let formatMoneyHelper = '';
      componentRegistry.useComponentPlugin('FormatCurrency', {
          name: 'Show Trailing Zeros',
          apply: () => ({
              afterRender: (element) => {
                  try {
                      formatMoneyHelper = element.getHelpers().formatMoney;
                      if (!formatMoneyHelper) return;
                  } catch (e) {
                      console.warn(e);
                  }
              },
          }),
      });
      componentRegistry.useComponentPlugin('SearchProductItem', {
         name: 'Customize product item ISW',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('.boost-sd__suggestion-queries-item--product[data-id="' + productId + '"]');
                  if (productItem) {
                     /* use pure js here */
                    if (productData.price_min != productData.price_max) {
                      let priceMin = formatMoneyHelper(Number(productData.price_min));
                      let priceMax = formatMoneyHelper(Number(productData.price_max));
                      const priceHtml = `<span class="boost-sd__suggestion-queries-item-amount boost-sd__suggestion-queries-item-amount--regular"><span class="boost-sd__format-currency"><span class="">${priceMin} - ${priceMax}</span></span></span>`;
                      productItem.querySelector('.boost-sd__suggestion-queries-item-price').innerHTML = '';
                      productItem.querySelector('.boost-sd__suggestion-queries-item-price').insertAdjacentHTML('beforeend', priceHtml);
                    }
                    ``
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemISW]);